///
/// EarthBrowser
///
/// Migration v21 to v22: Add bottom drawer width persistence
/// Created by Matt Giger on December 28, 2025
/// Copyright (c) 2025 Geodata Labs
///

interface BottomDrawerV21 {
	widthMode?: string
	width?: number
}

interface UserInterfaceV21 {
	bottomDrawer?: BottomDrawerV21
}

interface StateV21 {
	userInterface?: UserInterfaceV21
}

/**
 * Migration: v21 to v22
 *
 * Changes:
 * - Adds bottomDrawer.widthMode (default: 'full')
 * - Adds bottomDrawer.width (default: 900)
 */
export function migrateV21toV22(state: unknown): unknown {
	if (!state) return state

	const newState = { ...(state as StateV21) }

	if (newState.userInterface?.bottomDrawer) {
		const drawer = newState.userInterface.bottomDrawer
		newState.userInterface = {
			...newState.userInterface,
			bottomDrawer: {
				...drawer,
				widthMode: drawer.widthMode ?? "full",
				width: drawer.width ?? 900,
			},
		}
	}

	return newState
}
